module.exports = "images/7ans.2b9ed2b1.png";